<script>
import ResultsCarsComponent from '../catalog/ResultsCarsComponent';
import FiltersComponent from '../catalog/FiltersComponent.vue';
import OrderbyComponent from '../catalog/OrderbyComponent.vue';
import TagsComponent from '../catalog/TagsComponent.vue';

export default {
    props: {
        lastPage: Number,
        currentPage: Number,
        products: Array,
        dealerUser: Object,
        totalProducts: {
            type: Number,
            default: 0
        }
    },

    data: () => ({
        resultsContent: {
            products: null,
            lastPage: null,
            currentPage: null,
        },
        ordersBy: null,
        filters: null,
    }),

    components: {
        'results-cars-component' : ResultsCarsComponent,
        'filters-component' : FiltersComponent,
        'orderby-component' : OrderbyComponent,
        'tags-component' : TagsComponent,
    },

    beforeMount() {
        this.results = {
            products: this.products,
            lastPage: this.lastPage,
            currentPage: this.currentPage,
        };
    },

    computed: {
        results: {
            get: function() {
                return this.resultsContent;
            }, set: function( values ){
                this.resultsContent = values;
            }
        },

    },

    methods: {
        updateResults( values ) {
            this.results = {
                products: values.products,
                lastPage: values.lastPage,
                currentPage: values.currentPage,
            };
        },
        updateOrders( values ) {
            this.ordersBy = parseInt(values);
        },
        updateFilters( values ) {
            this.filters = values;
        }
    }

}
</script>

<template>
    <div class="gs:grid">

        <filters-component
            @newResults="updateResults"
            @orderEdit="updateOrders"
            @filters="updateFilters"
            :selectOrder="ordersBy"
            ref="filters"
            class="lg:col-4"
            :dealer-user="dealerUser"
        ></filters-component>

        <div class="backdrop"></div>

        <div class="lg:col-12">

            <button class="btn btn--green-ad btn--toggle-filters rounded-full fixed shadow-1 z-3 lg:hidden" id="trigger_filters_catalog">
                 <span class="tx-18 icon-filter"><i class="fas fa-filter"></i></span>
                <span class="tx-18 icon-times hidden"><i class="fas fa-times"></i></span>
            </button>

            <div class="box box--white flex justify-content-between p-3 mb-4">
                <tags-component :filters="filters"></tags-component>

                <orderby-component
                    @orderEdit="updateOrders"
                    :selectOrder="ordersBy"
                    ref="catalogOrder"
                    class="hidden lg:block w-fit"
                    :type="'large'"
                ></orderby-component>

            </div>

            <results-cars-component v-if="!!results.products"
                ref="results"
                :vehicles="results.products"
                :page="results.currentPage"
                :total="results.lastPage"
                :total-products="totalProducts"
            ></results-cars-component>

        </div>

    </div>
</template>
